<template>
  <el-tabs type="border-card">
    <el-tab-pane label="门禁设备" v-if="$route.query.tab != 'unBind'">
      <AccessControlDeviceOne />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import AccessControlDeviceOne from "./AccessControlDevice/AccessControlDeviceOne";

export default {
  name: "AccessControlDevice",
  components: {
    AccessControlDeviceOne,
  },
};
</script>

<style scoped></style>
